import React from 'react';
import { RootineStep, RootineStepperV2 } from '../../atoms/RootineStepperV2';
import { ReactComponent as UserIcon } from '../../images/user-01.svg';
import { ReactComponent as PackageIcon } from '../../images/package-minus.svg';
import { ReactComponent as FingerprintIcon } from '../../images/fingerprint-03.svg';
import { ReactComponent as StarsIcon } from '../../images/stars-02.svg';
import RootineButton from '../../atoms/RootineButton';
import { SHOPIFY_WEB_URL } from '../../config';
import { Box, Grid, Typography } from '@mui/material';
import { colors } from '../../utils/theme';

const steps: RootineStep[] = [
  {
    name: 'Lifestyle',
    title: 'Step 1',
    icon: <UserIcon />,
  },
  {
    name: 'At-home Mineral & Vitamin Test',
    title: 'Step 2',
    icon: <PackageIcon />,
  },
  {
    name: 'At-home DNA test',
    title: 'Step 3',
    icon: <FingerprintIcon />,
  },
  {
    name: 'Smart Multivitamin',
    title: 'Step 4',
    icon: <StarsIcon />,
  },
];
export const PersonalizationStepper = (): JSX.Element => {
  return (
    <Grid
      container
      flexDirection="column"
      sx={{
        py: 12,
        px: { xs: 3, md: 10, lg: 14 },
        borderBottom: `1px solid ${colors.greys.BORDER_GREY}`,
      }}
    >
      <Typography
        fontSize={16}
        sx={{ textTransform: 'uppercase', wordSpacing: 2 }}
      >
        How it works
      </Typography>
      <Typography
        variant="medium"
        sx={{ mt: 2, mb: 7, fontSize: { xs: 32, md: 40 } }}
      >
        Get accurate insights into your health by testing and analyzing your
        blood nutrient levels and genetic profile.
      </Typography>

      {/* TODO: Make activeStep dynamic */}
      <RootineStepperV2 steps={steps} activeStep={0} />
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 5.5, gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <RootineButton
            variation="primary"
            size="large"
            hideIcon
            label="Add at-home Vitamin & Mineral test + DNA test"
            url={`${SHOPIFY_WEB_URL}/products/comprehensive-test-bundle`}
            as="a"
            openNewTab
            sx={{ minWidth: 0.5 }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            gap: 2,
          }}
        >
          <Typography fontSize={18} variant="light">
            Already have a DNA test?
          </Typography>

          <a href="https://app.rhodiumsoftware.com/dashboard/dna/upload">
            <Typography fontSize={18} variant="light">
              Upload past results
            </Typography>
          </a>
        </Box>
      </Box>
    </Grid>
  );
};
